import { setterAction, createAction } from '../common/redux'
import * as t from './actionTypes'
import AccountSource from './Source'
import Source from '../interview/Source'
import * as authActions from '../auth/actions'
import * as completionActions from '../completion/actions'
import * as dashboardActions from '../dashboard/actions'
import * as interviewActions from '../interview/actions'
import * as generator from '../chatItemGenerator'
import {pushRoute} from '../common/route'
import { setUserContext, captureException } from "../common/error"
import InterviewSource from '../interview/Source'
import { inIframe } from '../common/common'

export const setVisits = setterAction(t.SET_VISITS)
export const setName = setterAction(t.SET_NAME)
export const setHasSelf = setterAction(t.SET_HAS_SELF)
export const setCurrentVisit = setterAction(t.SET_CURRENT_VISIT)
export const _setProfiles = setterAction(t.SET_PROFILES)
export const setProfileDirty = setterAction(t.SET_PROFILE_DIRTY)
export const profileError = setterAction(t.SET_PROFILE_ERROR)
export const visitError = setterAction(t.SET_VISIT_ERROR)
export const setFeatures = setterAction(t.SET_FEATURES)
export const setPredispositions = setterAction(t.SET_PREDISPOSITIONS)
export const setPredispositionAnswer = createAction(t.SET_PREDISPOSITION_ANSWER, "category", "token", "question", "option", "extension")
export const editPredispositions = createAction(t.EDIT_PREDISPOSITIONS, "category")
export const cancelEditPredispositions = createAction(t.CANCEL_EDIT_PREDISPOSITIONS, "category")

export const setProfiles = profiles => (dispatch, getState) => {
  dispatch(_setProfiles(profiles))
}

export const getProfiles = () => dispatch => {
  dispatch(interviewActions.setLoading(true, "account/getProfiles"))
  return AccountSource.getProfiles()
    .then(data => {
      let profiles = data.profiles

      // Determine if self profile exists
      let hasSelf = profiles.some(user => user.isself === true)

      // If we're in an iframe, ignore profiles that could be returned from a 
      // lingering session. We should be able to remove this once the new auth is
      // implemented.
      dispatch(setProfiles(inIframe() ? [] : profiles || []))
      dispatch(setHasSelf(hasSelf))
      return Source.permissions().then(data => {
        dispatch(interviewActions.setLoading(false))
        if (data.email && data.email !== "demo@buoyhealth.com") {
          setUserContext({ email: data.email })
          dispatch(authActions.setEmail(data.email))
          dispatch(authActions.setIsAnonymous(false))
          dispatch(authActions.setLoginStatus({ status: "ok", msg: "" }))
        } else if (!data.email) {
          dispatch(authActions.setLoginStatus({ status: "bad", msg: "" }))
        }
      }).catch(captureException)
    })
    .catch(error => {
      if (!error.response || error.response.status !== 403) {
        dispatch(interviewActions.genericError(error))
      }
    })
}



export const updateProfile = (id, first, last, sex, isself, year, month, day, age, height_ft, height_in, weight, isNew) => (dispatch, getState) => {
  const promise = isNew ? 
    InterviewSource.submitIdentifiers(first, age, sex, isself)
      .then(data => AccountSource.updateProfile(data.id, first, last, sex, isself, year, month, day, age, height_ft, height_in, weight)) 
      : AccountSource.updateProfile(id, first, last, sex, isself, year, month, day, age, height_ft, height_in, weight)

  return promise
    .then(() => {
      return AccountSource.getProfiles()
    })
    .then(data => {
      dispatch(setProfileDirty(false))
      dispatch(setProfiles(data.profiles || []))
    })
    .catch(error => {
      if (error && error.response && error.response.data) {
        dispatch(profileError(error.response.data.msg))
      } else {
        dispatch(profileError("An error occured."))
      }

      throw error
    })
}

export const getVisits = () => (dispatch) => {
  dispatch(setVisits({ loading: true }))
  dispatch(interviewActions.setLoading(true, "account/getVisits"))
  Source.getVisits().then(data => {
    dispatch(interviewActions.setLoading(false))
    dispatch(authActions.setIsAnonymous(false))
    dispatch(authActions.setEmail(data.email))
    dispatch(setName(data.name))
    dispatch(setVisits(data.visits))
  }).catch(error => {
    dispatch(interviewActions.setLoading(false))
    if (error.response && error.response.status === 403) {
      pushRoute('/login/')
    }
  })
}

export const getVisitResults = (visit) => (dispatch) => {
  dispatch(completionActions.setResults({}))
  dispatch(visitError({ status: false, msg: "" }))
  dispatch(interviewActions.setLoading(true, "account/getVisitResults"))
  Source.results(visit.token).then(data => {
    let results = data.results
    results.recap = true
    dispatch(setCurrentVisit(visit))
    dispatch(interviewActions.setChatItems([], false))
    dispatch(completionActions.processResults(results, data.is_alarm, true))
    dispatch(interviewActions.setLoading(false))
  }).catch(error => {
    dispatch(visitError({ status: true, msg: "Visit record does not exist." }))
    dispatch(interviewActions.setLoading(false))
  })
}

export const getVisitTranscript = () => (dispatch, getState) => {
  let {account, chatList} = getState()
  let {currentVisit} = account

  if (currentVisit.loaded)
    return

  Source.getVisitInterview(currentVisit.token).then(data => {
    dispatch(setCurrentVisit({...currentVisit, loaded: true}))
    let chatItems = []
    currentVisit.presentation.forEach(search => {
      if (!search.search)
        return
      let item = generator.symptomBubble(false, search.search)
      item.finished = true
      chatItems.push(item)
    })
    data.interview.forEach(question => {
      if (question.valid) {
        chatItems.push(generator.systemMessage(question.question))
        chatItems.push(generator.response(question.answer.join('; ')))
      }
    })
    chatItems.push(...chatList.items)
    dispatch(interviewActions.setChatItems(chatItems, false))
  }).catch(captureException)
}

export const deleteAccount = (reason) => (dispatch, getState) => {
  AccountSource.deleteAccount(reason).then(data => {
    dispatch(authActions.logout())
  }).catch(captureException)
}

export const initProfiles = () => dispatch => {
  // This action is for fetching profiles in the scenario of a user
  // logging in midway through the payment flow.
  return AccountSource.getProfiles().then(({ profiles }) =>
    dispatch(_setProfiles(profiles))
  ).catch(captureException)
}

// Predisposition actions
export const getProfileQuestions = profile_id => dispatch => {
  dispatch(setPredispositions({ loading: true }))
  return AccountSource.getProfileQuestions(profile_id)
    .then(data => {
      dispatch(setPredispositions(data))
    })
    .catch(e => {
      dispatch(interviewActions.setLoading(false))
      captureException(e)
    })
}

export const saveProfileAnswers = (profile_id, categories) => (
  dispatch,
  getState
) => {
  const { predispositions } = getState().account
  const answers = {}
  categories.forEach(category => {
    predispositions[category] && predispositions[category].questions.forEach(q => {
      if (q.answer) {
        answers[q.token] = Array.isArray(q.answer) ? q.answer : [q.answer]
        answers[q.token].forEach(a => {
          q.options[a].extensions.forEach(e => {
            answers[e.token] = Array.isArray(e.answer) ? e.answer : [e.answer]
          })
        })
      }
    })
  })
  return AccountSource.updateProfileQuestions(
    profile_id,
    JSON.stringify(answers)
  )
}

export const updateUserInsurancePlan = (office, plan, planHolder) => dispatch => {
  return AccountSource.updateUserInsurancePlan(office, plan, planHolder).then(response => {
    dispatch(dashboardActions.setPlanInformation(response))
  })
}

export const postUserInsurancePlan = (office, plan, planHolder) => dispatch => {
  return AccountSource.postUserInsurancePlan(office, plan, planHolder).then(response => {
    dispatch(dashboardActions.setPlanInformation(response))
  })
}



// WEBPACK FOOTER //
// ./assets/account/actions.js